/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getOrderImageRecaptureDetectionCustomerSummaryTable = params => {
  return axios.post(`${base}/image-recapture-detection/query_customer_summary`, params)
}
export const getOrderImageRecaptureDetectionProjectSummaryTable = params => {
  return axios.post(`${base}/image-recapture-detection/query_project_summary`, params)
}
export const getOrderImageRecaptureDetectionBatchSummaryTable = params => {
  return axios.post(`${base}/image-recapture-detection/query_batch_summary`, params)
}
export const getOrderImageRecaptureDetectionImageTable = params => {
  return axios.post(`${base}/image-recapture-detection/query_image`, params)
}
export const getOrderImageRecaptureDetectionImageDetail = params => {
  return axios.get(`${base}/image-recapture-detection/image_${params.id}`)
}
export const setOrderImageRecaptureDetectionImageStatus = params => {
  return axios.post(`${base}/image-recapture-detection/set_image_status`, params)
}
export const setOrderImageRecaptureDetectionImageStatusBySearch = params => {
  return axios.post(`${base}/image-recapture-detection/set_image_status_by_search`, params)
}
export const exportOrderImageRecaptureDetectionData = params => {
  return axios.get(`${base}/exportOrderImageRecaptureDetectionData/${params.id}`, {params})
}
export const createOrderImageRecaptureDetectionData = params => {
  return axios.post(`${base}/createOrderImageRecaptureDetectionData`, params)
}
export const updateOrderImageRecaptureDetectionData = params => {
  return axios.post(`${base}/updateOrderImageRecaptureDetectionData/${params.id}`, params)
}
export const deleteOrderImageRecaptureDetectionData = params => {
  return axios.post(`${base}/deleteOrderImageRecaptureDetectionData/${params.id}`, params)
}



// WEBPACK FOOTER //
// ./src/views/order-image-recapture-detection/order-image-recapture-detection.api.js